import { MENU_NAME } from "@core/constants";

export const lstComparison = [
  { name: '一致', value: 'equal', type: '1' },
  { name: '不一致', value: 'not_equal', type: '2' },
  { name: '含む', value: 'like', type: '3' },
  { name: '含まない', value: 'not_like', type: '4' },
  { name: '以上', value: 'greater_than', type: '5' },
  { name: '以下', value: 'less_than', type: '6' },
  { name: '始まる', value: 'like_left', type: '7' },
  { name: '終わる', value: 'like_right', type: '8' },
  { name: '記録がある', value: 'has_record', type: '9' },
]

export const typeLst: any[]= [
  {type: 'と一致する記録', value: 'equal'},
  {type: 'と一致しない記録', value: 'not_equal'},
  {type: '回答があれば連携', value: 'has_answer'},
  {type: '含む記録', value: 'like'},
  {type: '含まない記録', value: 'not_like'},
  {type: 'フリーワードと回数を指定する', value: 'lst_compare'},
  {type: 'を含む記録', value: 'answer_tag_like'},
]

export const lstScreen = [
  { value: "01", name: MENU_NAME.HOME},
  { value: "02", name: MENU_NAME.BATH_SCREEN},
  { value: "03", name: MENU_NAME.EXCREATION},
  { value: "04", name: MENU_NAME.USER_DASHBOARD}
]

export const kirokuColNames = {
  tsusho:["bathe", "training", "snack", "oral", "excretion_list", "excretion_induction", "enteral_feeding", "recheck"],
  nyusho:["bathe", "training", "snack", "oral", "enteral_feeding", "recheck"],
  excretion: ["urination", "defecation", "excretion-procedures", "elapsed_time", "enteral_feeding"],
  user_dashboard:[ "care_plan","meal","bathe","training_implement","training_cancel"]
}

export const defaultData = {
  comparison: "",
  val: "",
  dockbn: "",
  ttlkbn: "",
  ttlcd: "",
  itemid: "",
  notekbn: "",
  itemname: "",
  childids: [],
  tag:"",
}

export const colLake = [
  {
    field: 'notice_list',
    colname: 'notice_list',
    displayname: "連絡",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'vital',
    colname: 'temperature',
    displayname: "体温",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'vital',
    colname: 'bp_top',
    displayname: "血圧(上)",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'vital',
    colname: 'bp_bottom',
    displayname: "血圧(下)",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'vital',
    colname: 'pulse',
    displayname: "脈拍",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'vital',
    colname: 'spo2',
    displayname: "SPO2",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'bathe',
    colname: 'bathe_noplans',
    displayname: "入浴(予定なし)",
    isShowKirokuCondition: true,
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'bathe',
    colname: 'bathe_scheduled',
    displayname: "入浴(予定あり)",
    isShowKirokuCondition: true,
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'bathe_method',
    colname: 'bathe_method',
    displayname: "入浴方法",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'vital',
    colname: 'recheck',
    displayname: "再検",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'bathe',
    colname: 'bathe_implement',
    displayname: "入浴(実施)",
    isShowKirokuCondition: true,
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'bathe',
    colname: 'bathe_cancel',
    displayname: "入浴(中止)",
    isShowKirokuCondition: true,
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'training',
    colname: 'training_schedule',
    displayname: "機能訓練(予定あり)",
    isShowKirokuCondition: true,
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'training',
    colname: 'training_implement',
    displayname: "機能訓練(実施)",
    isShowKirokuCondition: true,
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'training',
    colname: 'training_cancel',
    displayname: "機能訓練(中止)",
    isShowKirokuCondition: true,
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'meal',
    colname: 'meal_main',
    displayname: "主食",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'meal',
    colname: 'meal_sub',
    displayname: "副食",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'meal_moisture',
    colname: 'meal_moisture',
    displayname: "食事水分",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'snack',
    colname: 'snack',
    displayname: "おやつ",
    isShowKirokuCondition: true,
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'snack',
    colname: 'snack_moisture',
    displayname: "おやつ水分",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'moisture',
    colname: 'moisture',
    displayname: "水分量",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'oral',
    colname: 'oral',
    displayname: "口腔",
    isShowKirokuCondition: true,
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'oral',
    colname: 'oral_scheduled',
    displayname: "口腔(予定あり)",
    isShowKirokuCondition: true,
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'medicine_list_drug',
    colname: 'medicine_list',
    displayname: "服薬",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'medicine_list',
    colname: 'medicine_detail',
    displayname: "定期与薬 服薬内容",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'medicine_list',
    colname: 'medicine_type',
    displayname: "臨時与薬 種類",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'medicine_list',
    colname: 'medicine_name',
    displayname: "臨時与薬 薬名",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'medicine_list',
    colname: 'medicine_dose',
    displayname: "臨時与薬 用量",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'excretion_list',
    colname: 'urination',
    displayname: "排尿",
    isShowKirokuCondition: true,
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'excretion_list',
    colname: 'defecation',
    displayname: "排便",
    isShowKirokuCondition: true,
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'excretion_list',
    colname: 'no-excretion',
    displayname: "排泄無し",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'excretion_list',
    colname: 'excretion-procedures',
    displayname: "排泄処置",
    isShowKirokuCondition: true,
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'excretion_list',
    colname: 'specialized-care',
    displayname: "専門ケア",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'elapsed_time',
    colname: 'elapsed_time',
    displayname: "経過時間",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'oral',
    colname: 'oral_implement',
    displayname: "歯磨き(実施)",
    isShowKirokuCondition: true,
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'oral',
    colname: 'oral_cancel',
    displayname: "歯磨き(中止)",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'enteral_feeding',
    colname: 'enteral_feeding',
    displayname: "経管栄養",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'notice_list',
    colname: 'leave_reason',
    displayname: "中止理由",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'care_plan',
    colname: 'needs',
    displayname: "ニーズ",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'care_plan',
    colname: 'long-term-goals',
    displayname: "長期目標",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'care_plan',
    colname: 'short-term-goals',
    displayname: "短期目標",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'care_plan',
    colname: 'service-details',
    displayname: "サービス内容",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'image',
    colname: 'image',
    displayname: "写真",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'video',
    colname: 'video',
    displayname: "動画",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'image',
    colname: 'img_type',
    displayname: "分類",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'image',
    colname: 'comment',
    displayname: "コメント",
    condition: [{ id: "", ...defaultData }]
  },
  {
    field: 'video',
    colname: 'remarks',
    displayname: "備考",
    condition: [{ id: "", ...defaultData }]
  },
];


export const tsushoColNames = 
[
  "notice_list", "temperature", "bp_top", "bp_bottom", "pulse", "spo2",
  "bathe_scheduled", "bathe_implement", "bathe_cancel",
  "training_schedule", "training_implement", "training_cancel",
  "meal_main", "meal_sub", "snack", "moisture", "oral", "medicine_list",
  "urination", "defecation","leave_reason", "enteral_feeding"
]

export const nyushoColNames = 
[
  "temperature", "bp_top", "bp_bottom", "pulse", "spo2",
  "meal_main", "meal_sub", "meal_moisture", "moisture",
  "oral_implement", "oral_cancel",
  "bathe_implement", "bathe_cancel",
  "snack", "snack_moisture", "medicine_list", "enteral_feeding",
  "training_implement", "training_cancel"
]

export const excreationColNames = 
[
  "urination", "defecation", "no-excretion",
  "excretion-procedures", "elapsed_time",
//   "specialized-care",
  "meal_main", "meal_sub", "moisture", "enteral_feeding"
]

export const switchBtnColNames = 
[
  "meal_moisture", "snack_moisture"
]
// export const userDashboardColNames = 
// [
//   "temperature", "bp_top", "bp_bottom", "pulse", "spo2",
//   "meal_main", "meal_sub", "meal_moisture",
//   "moisture",
//   "bathe_implement","bathe_cancel",
//   "urination","defecation","no-excretion","excretion-procedures",
//   "training_implement",
//   "medicine_detail", "medicine_type", "medicine_name", "medicine_dose",
//   "needs", "long-term-goals", "short-term-goals", "service-details", "enteral_feeding",
//   "image", "img_type", "comment", "video","remarks"
// ]

// export const bathingColNamesTsusho = 
// [
//   "temperature", "bp_top", "bp_bottom", "pulse", "spo2", "bathe_method",
//   "bathe_scheduled", "bathe_implement", "bathe_cancel", "recheck"
// ]

// export const bathingColNamesNyusho = 
// [
//   "temperature", "bp_top", "bp_bottom", "pulse", "spo2", "bathe_method",
//   "bathe_implement", "bathe_cancel", "recheck"
// ]

// export const schedule = 
// [
//   "leave_reason",
//   "training_schedule", "training_implement", "training_cancel",
//   "bathe_scheduled"
// ]

// export const record = 
// [
//   "temperature", "bp_top", "bp_bottom", "pulse", "spo2","recheck",
//   "meal_main","meal_sub","enteral_feeding",
//   "oral_implement","oral_cancel",
//   "snack","snack_moisture",
//   "meal_moisture",
//   "bathe_implement","bathe_cancel","bathe_method",
//   "medicine_list",
//   "medicine_detail", "medicine_type", "medicine_name", "medicine_dose",
//   "urination","defecation","no-excretion","excretion-procedures",
//   "image", "img_type", "comment", "video","remarks",
//   "notice_list",
//   "oral",
  
// ]

// export const report = 
// [
//   "needs","long-term-goals","short-term-goals","service-details","enteral_feeding",
// ]

export const scheduleTsusho = 
[
  "training_schedule", 
  "bathe_scheduled",
  "oral_scheduled",
]

export const scheduleNyusho = 
[

]

export const recordTsusho =
  [
    "notice_list",
    "temperature", "bp_top", "bp_bottom", "pulse", "spo2", "recheck",
    "meal_main", "meal_sub", "enteral_feeding",
    "moisture",
    "bathe_implement", "bathe_cancel", "bathe_method",
    "medicine_list",
    "snack","oral",
    "urination", "defecation",
    "training_implement","training_cancel","leave_reason",
  ]

export const recordNyusho =
  [
    "temperature", "bp_top", "bp_bottom", "pulse", "spo2", "recheck",
    "meal_main", "meal_sub", "enteral_feeding",
    "oral_implement", "oral_cancel",
    "moisture",
    "snack", "snack_moisture",
    "meal_moisture",
    "bathe_implement", "bathe_cancel", "bathe_method",
    "medicine_list",
    "medicine_detail", "medicine_type", "medicine_name", "medicine_dose",
    "urination", "defecation", "no-excretion", "excretion-procedures", "elapsed_time",
    "image", "img_type", "comment", "video", "remarks",
    "training_implement", "training_cancel"
  ]

export const reportTsusho =
  [
  ]

export const reportNyusho =
  [
    "needs", "long-term-goals", "short-term-goals", "service-details"
  ]
